import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
@Component({
  selector: 'app-advanced-settings-intro',
  templateUrl: './advanced-settings-intro.component.html',
  styleUrls: [
    './advanced-settings-intro.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsIntroComponent implements OnInit {

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.loadWizardText();
  }

  @ViewChild('wizardText')
  public wizardText: ElementRef;
  public async loadWizardText() {

    // setTimeout(() => {
    //   const content = document.querySelector('.content');
    //   if (content) {
    //     content.scrollIntoView();
    //   }
    // }, 0)

    const wait = (time) => {
      return new Promise((res) => setTimeout(res, time))
    }

    const text = `The more you engage in the world of Kachiing, the faster you will level up and unlock exciting new features that enhance your experience! Each action, interaction, and milestone brings you closer to discovering exclusive benefits and powerful tools. So, keep exploring, engaging, and growing your presence to access everything Kachiing has to offer!`;
    for (let i = 0; i < text.length; i++) {
      if (this.wizardText) {
        this.wizardText.nativeElement.textContent += text[i]
        await wait(60);
      }
    }
  }
}
